
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512.001 512.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M345.075 126.02V69.268c0-8.894-7.21-16.104-16.104-16.104H183.029c-8.894 0-16.104 7.21-16.104 16.104v56.752h-45.663v332.818h269.475V126.02h-45.662zm-32.208-.128H199.133v-40.52h113.733v40.52zM54.741 126.02C24.557 126.02 0 150.576 0 180.76v223.337c0 30.183 24.557 54.74 54.741 54.74h34.313V126.02H54.741zM457.26 126.02h-34.313v332.818h34.313c30.184 0 54.741-24.557 54.741-54.74V180.76c-.001-30.184-24.558-54.74-54.741-54.74z"}})])
          )
        }
      }
    